import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  activationProductApi,
  cloneProductApi,
  deleteFileApi,
  deleteProductExtraUploadsApi,
  deleteColorApi,
  deleteProductApi,
  deleteSizeApi,
  getAllProductApi,
  getDeliveryZoneApi,
  getAllSellerProductApi,
  getSingleProductApi,
  multipleFileUploadApi,
  postProductSizeApi,
  postProductFloatVideoApi,
  updateColorApi,
  updateProductSizeApi,
  updateProductPriorityApi,
  updateProductApi,
  updateSizeApi,
  uploadColorApi,
  uploadPreivewIconAPI,
  uploadProductApi,
  uploadSizeApi,
} from "../../api/ecommerce/ProductApi";

const initialState = {
  products: {},
  singleProduct: {},
  deliveryZones: [],
  productVariants: [],
  imageFileResponse: [],
  videoFileResponse: [],
  productResponse: {},
  colorResponse: {},
  sizeResponse: {},
  filters: {},
  keyword: "",
  sku: "",
  searchMode: "all",
  category: "",
  sortdir: "desc",
  sortby: "priority",
  editProduct: {
    isEdit: false,
    body: {},
  },

  stepper: 1,
  customizationVariantTab: 0,
  categoryType: "",

  isVideo: false,

  loading: false,
  deleting: false,
  fileUploading: false,
  uploading: false,
  deliveryZoneLoading: false,
  iconLoading: null,
  uploadedPreview: null,
  floatingVideoSaving: false,
  floatingVideoResponse: null,
  extraUploadDeleting: null,
  cloning: false,
  cloneResponse: null,
  priorityUpdatingId: null,
  productListRequestId: null,
};

export const multipleImageUpload = createAsyncThunk(
  "product/multipleImageUpload",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await multipleFileUploadApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const deleteSingleImage = createAsyncThunk(
  "product/deleteSingleImage",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await deleteFileApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const multipleVideoUpload = createAsyncThunk(
  "product/multipleVideoUpload",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await multipleFileUploadApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const deleteSingleVideo = createAsyncThunk(
  "product/deleteSingleVideo",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await deleteFileApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const getAllProduct = createAsyncThunk(
  "product/getAllProduct",
  async (payload, { rejectWithValue }) => {
    try {
      console.log("category 2", payload)
      const response = await getAllProductApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const getAllSellerProduct = createAsyncThunk(
  "product/getAllSellerProduct",
  async (payload, { rejectWithValue }) => {
    try {
      console.log("category 3", payload)
      const response = await getAllSellerProductApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const getSingleProduct = createAsyncThunk(
  "product/getSingleProduct",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getSingleProductApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const getDeliveryZones = createAsyncThunk(
  "product/getDeliveryZones",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getDeliveryZoneApi();
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const uploadProduct = createAsyncThunk(
  "product/uploadProduct",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await uploadProductApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const deleteProductExtraUploads = createAsyncThunk(
  "product/deleteProductExtraUploads",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await deleteProductExtraUploadsApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.response?.data?.message || error?.message,
      });
    }
  }
);

export const cloneProduct = createAsyncThunk(
  "product/cloneProduct",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await cloneProductApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.response?.data?.message || error?.message,
      });
    }
  }
);

export const postProductFloatVideo = createAsyncThunk(
  "product/postProductFloatVideo",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await postProductFloatVideoApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const updateProduct = createAsyncThunk(
  "product/updateProduct",
  async (payload, { getState, rejectWithValue }) => {
    try {
      const productState = getState()?.product || {};
      const existingPriority =
        payload?.priority ??
        productState.singleProduct?.priority ??
        productState.editProduct?.body?.priority;
      const updatePayload =
        existingPriority == null
          ? payload
          : {
            ...payload,
            priority: existingPriority,
          };
      const response = await updateProductApi(updatePayload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const deleteProduct = createAsyncThunk(
  "product/deleteProduct",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await deleteProductApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const activationProduct = createAsyncThunk(
  "product/activationProduct",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await activationProductApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const updateProductPriority = createAsyncThunk(
  "product/updateProductPriority",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateProductPriorityApi(payload);
      return {
        ...response?.data,
        requestedProductId: payload?.productId,
        requestedPriority: payload?.priority,
      };
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.response?.data?.message || error?.message,
      });
    }
  }
);

export const uploadColor = createAsyncThunk(
  "product/uploadColor",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await uploadColorApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const updateColor = createAsyncThunk(
  "product/updateColor",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateColorApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const deleteColor = createAsyncThunk(
  "product/deleteColor",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await deleteColorApi(payload);
      return { ...response?.data, deletedColorId: payload?.colorId };
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.response?.data?.message || error?.message,
      });
    }
  }
);

export const uploadSize = createAsyncThunk(
  "product/uploadSize",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await uploadSizeApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const updateSize = createAsyncThunk(
  "product/updateSize",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateSizeApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const postProductSize = createAsyncThunk(
  "product/postProductSize",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await postProductSizeApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.response?.data?.message || error?.message,
      });
    }
  }
);

export const updateProductSize = createAsyncThunk(
  "product/updateProductSize",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateProductSizeApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.response?.data?.message || error?.message,
      });
    }
  }
);

export const deleteSize = createAsyncThunk(
  "product/deleteSize",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await deleteSizeApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  }
);

export const uploadPreivewIcon = createAsyncThunk(
  "product/uploadPreivewIcon",
  async (file, { rejectWithValue }) => {
    try {
      const response = await uploadPreivewIconAPI(file);
      return response.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  },
);

const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    addKeywordSearch: (state, action) => {
      state.keyword = action.payload;
    },
    addSku: (state, action) => {
      state.sku = action.payload;
    },
    setProductSearch: (state, action) => {
      const query = action.payload?.query || "";
      const mode = action.payload?.mode || state.searchMode || "all";

      state.searchMode = mode;
      state.keyword = mode === "sku" ? "" : query;
      state.sku = mode === "sku" ? query : "";
    },
    addSortDir: (state, action) => {
      state.sortdir = action.payload;
    },
    addCategoryType: (state, action) => {
      console.log('category 1', action.payload)
      state.category = action.payload;
    },
    addSortBy: (state, action) => {
      state.sortby = action.payload;
    },
    clearAllFilter: (state, action) => {
      state.keyword = "";
      state.sku = "";
      state.searchMode = "all";
      state.sortby = "priority";
      state.sortdir = "desc";
      state.category = "";
    },
    setEditProduct: (state, action) => {
      state.editProduct = {
        isEdit: action.payload.isEdit,
        body: action.payload.body,
      };
    },
    setStepper: (state, action) => {
      state.stepper = action.payload;
    },
    setCustomizationVariantTab: (state, action) => {
      state.customizationVariantTab = action.payload;
    },
    setIsVideo: (state, action) => {
      state.isVideo = action.payload;
    },
    setCategoryType: (state, action) => {
      state.categoryType = action.payload;
    },
    setProductVariants: (state, action) => {
      state.productVariants = action?.payload || [];
    },
    clearProductFormState: (state) => {
      state.singleProduct = {};
      state.productVariants = [];
      state.productResponse = {};
      state.colorResponse = {};
      state.sizeResponse = {};
      state.imageFileResponse = [];
      state.videoFileResponse = [];
      state.editProduct = {
        isEdit: false,
        body: {},
      };
      state.stepper = 1;
      state.customizationVariantTab = 0;
      state.categoryType = "";
      state.isVideo = false;
      state.uploadedPreview = null;
      state.iconLoading = null;
      state.cloneResponse = null;
      state.cloning = false;
      state.extraUploadDeleting = null;
    },
  },
  extraReducers: (builder) => {
    // upload images
    builder.addCase(multipleImageUpload.pending, (state) => {
      state.fileUploading = true;
    });
    builder.addCase(multipleImageUpload.fulfilled, (state, action) => {
      state.imageFileResponse = action.payload?.response;
      state.isVideo = false;
      state.fileUploading = false;
    });
    builder.addCase(multipleImageUpload.rejected, (state) => {
      state.fileUploading = false;
      state.isVideo = false;
    });

    // delete images
    builder.addCase(deleteSingleImage.pending, (state) => {
      state.fileUploading = true;
    });
    builder.addCase(deleteSingleImage.fulfilled, (state, action) => {
      state.imageFileResponse = action.payload?.response;
      state.isVideo = false;
      state.fileUploading = false;
    });
    builder.addCase(deleteSingleImage.rejected, (state) => {
      state.fileUploading = false;
      state.isVideo = false;
    });

    // upload videos
    builder.addCase(multipleVideoUpload.pending, (state) => {
      state.fileUploading = true;
    });
    builder.addCase(multipleVideoUpload.fulfilled, (state, action) => {
      state.videoFileResponse = action.payload?.response;
      state.isVideo = false;
      state.fileUploading = false;
    });
    builder.addCase(multipleVideoUpload.rejected, (state) => {
      state.fileUploading = false;
    });

    // delete images
    builder.addCase(deleteSingleVideo.pending, (state) => {
      state.fileUploading = true;
    });
    builder.addCase(deleteSingleVideo.fulfilled, (state, action) => {
      state.videoFileResponse = action.payload?.response;
      state.isVideo = false;
      state.fileUploading = false;
    });
    builder.addCase(deleteSingleVideo.rejected, (state) => {
      state.fileUploading = false;
      state.isVideo = false;
    });

    // get products
    builder.addCase(getAllProduct.pending, (state, action) => {
      state.loading = true;
      state.productListRequestId = action.meta.requestId;
    });
    builder.addCase(getAllProduct.fulfilled, (state, action) => {
      if (state.productListRequestId !== action.meta.requestId) {
        return;
      }

      state.products = action.payload?.response;
      state.loading = false;
      state.productListRequestId = null;
    });
    builder.addCase(getAllProduct.rejected, (state, action) => {
      if (state.productListRequestId !== action.meta.requestId) {
        return;
      }

      state.loading = false;
      state.productListRequestId = null;
    });

    // get seller products
    builder.addCase(getAllSellerProduct.pending, (state, action) => {
      state.loading = true;
      state.productListRequestId = action.meta.requestId;
    });
    builder.addCase(getAllSellerProduct.fulfilled, (state, action) => {
      if (state.productListRequestId !== action.meta.requestId) {
        return;
      }

      state.products = action.payload?.response;
      state.loading = false;
      state.productListRequestId = null;
    });
    builder.addCase(getAllSellerProduct.rejected, (state, action) => {
      if (state.productListRequestId !== action.meta.requestId) {
        return;
      }

      state.loading = false;
      state.productListRequestId = null;
    });

    // get single product
    builder.addCase(getSingleProduct.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSingleProduct.fulfilled, (state, action) => {
      state.singleProduct = action.payload?.response;
      state.productVariants = action.payload?.response?.productVariants || [];
      state.loading = false;
    });
    builder.addCase(getSingleProduct.rejected, (state) => {
      state.loading = false;
    });

    // get delivery zones
    builder.addCase(getDeliveryZones.pending, (state) => {
      state.deliveryZoneLoading = true;
    });
    builder.addCase(getDeliveryZones.fulfilled, (state, action) => {
      state.deliveryZones = action.payload?.response || [];
      state.deliveryZoneLoading = false;
    });
    builder.addCase(getDeliveryZones.rejected, (state) => {
      state.deliveryZoneLoading = false;
    });

    // upload products
    builder.addCase(uploadProduct.pending, (state) => {
      state.uploading = true;
    });
    builder.addCase(uploadProduct.fulfilled, (state, action) => {
      state.productResponse = action.payload?.response;
      state.singleProduct = action.payload?.response;
      state.productVariants = action.payload?.response?.productVariants || [];
      state.uploading = false;
    });
    builder.addCase(uploadProduct.rejected, (state) => {
      state.uploading = false;
    });

    // clone product
    builder.addCase(cloneProduct.pending, (state) => {
      state.cloning = true;
      state.cloneResponse = null;
    });
    builder.addCase(cloneProduct.fulfilled, (state, action) => {
      state.cloneResponse = action.payload?.response ?? action.payload;
      state.cloning = false;
    });
    builder.addCase(cloneProduct.rejected, (state) => {
      state.cloning = false;
    });

    builder.addCase(postProductFloatVideo.pending, (state) => {
      state.floatingVideoSaving = true;
    });
    builder.addCase(postProductFloatVideo.fulfilled, (state, action) => {
      state.floatingVideoResponse = action.payload?.response ?? action.payload;
      state.floatingVideoSaving = false;
    });
    builder.addCase(postProductFloatVideo.rejected, (state) => {
      state.floatingVideoSaving = false;
    });

    builder.addCase(deleteProductExtraUploads.pending, (state, action) => {
      const payload = action.meta.arg || {};
      state.extraUploadDeleting = payload.deleteDemoVid
        ? "demo"
        : payload.deletePreviewUpload
          ? "preview"
          : "floating";
    });
    builder.addCase(deleteProductExtraUploads.fulfilled, (state) => {
      state.extraUploadDeleting = null;
    });
    builder.addCase(deleteProductExtraUploads.rejected, (state) => {
      state.extraUploadDeleting = null;
    });

    // update products
    builder.addCase(updateProduct.pending, (state) => {
      state.uploading = true;
    });
    builder.addCase(updateProduct.fulfilled, (state, action) => {
      state.productResponse = action.payload?.response;
      state.uploading = false;
    });
    builder.addCase(updateProduct.rejected, (state) => {
      state.uploading = false;
    });

    // update products
    builder.addCase(deleteProduct.pending, (state) => {
      state.uploading = true;
    });
    builder.addCase(deleteProduct.fulfilled, (state, action) => {
      // state.productResponse = action.payload?.response;
      state.uploading = false;
    });
    builder.addCase(deleteProduct.rejected, (state) => {
      state.uploading = false;
    });

    // activate/disactivate products
    builder.addCase(activationProduct.pending, (state) => {
      state.uploading = true;
    });
    builder.addCase(activationProduct.fulfilled, (state, action) => {
      const updatedProduct = action.payload?.response || {};

      if (Array.isArray(state.products?.content)) {
        state.products.content = state.products.content.map((item) =>
          item.productId === updatedProduct.productId ? updatedProduct : item
        );
      }
      state.uploading = false;
    });
    builder.addCase(activationProduct.rejected, (state) => {
      state.uploading = false;
    });

    // update product priority
    builder.addCase(updateProductPriority.pending, (state, action) => {
      state.priorityUpdatingId = action.meta.arg?.productId ?? null;
    });
    builder.addCase(updateProductPriority.fulfilled, (state, action) => {
      const updatedProduct = action.payload?.response;
      const productId =
        updatedProduct?.productId ?? action.payload?.requestedProductId;
      const priority =
        updatedProduct?.priority ?? action.payload?.requestedPriority;

      if (Array.isArray(state.products?.content)) {
        state.products.content = state.products.content.map((item) =>
          item.productId === productId
            ? { ...item, ...(updatedProduct || {}), priority }
            : item
        );
      }
      state.priorityUpdatingId = null;
    });
    builder.addCase(updateProductPriority.rejected, (state) => {
      state.priorityUpdatingId = null;
    });

    // upload color
    builder.addCase(uploadColor.pending, (state) => {
      state.uploading = true;
    });
    builder.addCase(uploadColor.fulfilled, (state, action) => {
      const createdColor = action.payload?.response;

      state.colorResponse = createdColor;
      if (createdColor?.id) {
        const existingColorIndex = state.productVariants.findIndex(
          (color) => String(color?.id) === String(createdColor.id)
        );

        if (existingColorIndex >= 0) {
          state.productVariants[existingColorIndex] = createdColor;
        } else {
          state.productVariants.push(createdColor);
        }

        if (state.singleProduct) {
          state.singleProduct.productVariants = [...state.productVariants];
        }
      }
      state.uploading = false;
    });
    builder.addCase(uploadColor.rejected, (state) => {
      state.uploading = false;
    });

    // update color
    builder.addCase(updateColor.pending, (state) => {
      state.uploading = true;
    });
    builder.addCase(updateColor.fulfilled, (state, action) => {
      state.colorResponse = action.payload?.response;
      state.uploading = false;
    });
    builder.addCase(updateColor.rejected, (state) => {
      state.uploading = false;
    });

    // delete color
    builder.addCase(deleteColor.pending, (state) => {
      state.uploading = true;
    });
    builder.addCase(deleteColor.fulfilled, (state, action) => {
      const deletedColorId = action.payload?.deletedColorId;
      state.productVariants = state.productVariants.filter(
        (color) => String(color?.id) !== String(deletedColorId)
      );
      if (state.singleProduct) {
        state.singleProduct.productVariants = [...state.productVariants];
      }
      state.uploading = false;
    });
    builder.addCase(deleteColor.rejected, (state) => {
      state.uploading = false;
    });

    // upload size
    builder.addCase(uploadSize.pending, (state) => {
      state.uploading = true;
    });
    builder.addCase(uploadSize.fulfilled, (state, action) => {
      state.sizeResponse = action.payload?.response;
      state.uploading = false;
    });
    builder.addCase(uploadSize.rejected, (state) => {
      state.uploading = false;
    });

    // update size
    builder.addCase(updateSize.pending, (state) => {
      state.uploading = true;
    });
    builder.addCase(updateSize.fulfilled, (state, action) => {
      state.sizeResponse = action.payload?.response;
      state.uploading = false;
    });
    builder.addCase(updateSize.rejected, (state) => {
      state.uploading = false;
    });

    // post product size
    builder.addCase(postProductSize.pending, (state) => {
      state.uploading = true;
    });
    builder.addCase(postProductSize.fulfilled, (state, action) => {
      state.sizeResponse = action.payload?.response;
      state.uploading = false;
    });
    builder.addCase(postProductSize.rejected, (state) => {
      state.uploading = false;
    });

    // update product size
    builder.addCase(updateProductSize.pending, (state) => {
      state.uploading = true;
    });
    builder.addCase(updateProductSize.fulfilled, (state, action) => {
      state.sizeResponse = action.payload?.response;
      state.uploading = false;
    });
    builder.addCase(updateProductSize.rejected, (state) => {
      state.uploading = false;
    });

    // delete size
    builder.addCase(deleteSize.pending, (state) => {
      state.uploading = true;
    });
    builder.addCase(deleteSize.fulfilled, (state, action) => {
      state.sizeResponse = action.payload?.response;
      state.uploading = false;
    });
    builder.addCase(deleteSize.rejected, (state) => {
      state.uploading = false;
    });

    // upload preview icon
    builder.addCase(uploadPreivewIcon.pending, (state) => {
      state.iconLoading = false;
    });
    builder.addCase(uploadPreivewIcon.fulfilled, (state, action) => {
      state.uploadedPreview = action?.payload?.response;
      state.iconLoading = true;
    });
    builder.addCase(uploadPreivewIcon.rejected, (state) => {
      state.iconLoading = null;
    });
  },
});

export const {
  addKeywordSearch,
  addSku,
  setProductSearch,
  addCategoryType,
  addSortBy,
  addSortDir,
  clearAllFilter,
  setEditProduct,
  setStepper,
  setCustomizationVariantTab,
  setIsVideo,
  setCategoryType,
  setProductVariants,
  clearProductFormState,
} = productSlice.actions;
export default productSlice.reducer;
